import { tss } from 'tss-react';

import { ButtonGroup } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Detail/ButtonGroup';
import Informations from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Detail/Informations';
import { IngredientListAccordion } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Detail/IngredientListAccordion';
import IngredientListComponentButtons from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Detail/IngredientListComponentButtons';
import { Inputs } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Detail/Inputs';
import { IncorporationShareWithIndex } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Detail/Sidebar';
import Sidebar from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Detail/Sidebar';
import { RecipeErpViewComponentProps } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Index';
import useCurrency from 'hooks/redux/useCurrency';
import { useReaction } from 'hooks/useReaction';
import * as Calculation from 'types/Recipe/Calculation';
import * as ErpRecipe from 'types/Recipe/Detail/ErpNew/ErpRecipe';
import { Recipe } from 'types/Recipe/Recipe';
import { Segment } from 'types/Recipe/Segment';
import * as SegmentList from 'types/Recipe/SegmentList';

export type IProps = RecipeErpViewComponentProps & {
	erpRecipe: ErpRecipe.Type;
	segments: Segment[];
	recipe: Recipe;
	incorporationShares: IncorporationShareWithIndex[];
};

export const Index = (props: IProps) => {
	const currency = useCurrency();
	const { classes } = useStyles();

	const [calculation] = useReaction(
		null,
		async (_signal: number) => {
			const mergedSegments = SegmentList.mergeWithProductMappings(
				props.segments,
				props.erpRecipe.ingredients
			);
			return await Calculation.callApi(
				SegmentList.mapToApi({
					segments: mergedSegments,
					incorporationShares: props.incorporationShares,
					currencyCode: currency,
					ingredients: props.erpRecipe.ingredients,
				})
			);
		},
		props.state.recalculationSignal
	);

	return (
		<div>
			<div className={classes.header}>
				<ButtonGroup {...props} />
				<Inputs {...props} />
			</div>
			<div style={{ margin: '20px 0px' }}>
				<Informations {...props} />
			</div>
			<div className="row">
				<div className="col-lg-9">
					<fieldset>
						<IngredientListComponentButtons {...props} />
						<IngredientListAccordion
							{...props}
							calculation={calculation ?? Calculation.create()}
							isLoaded={true}
						/>
					</fieldset>
				</div>
				<div className="col-lg-3">
					<Sidebar {...props} calculation={calculation ?? Calculation.create()} />
				</div>
			</div>
		</div>
	);
};

export const useStyles = tss.create({
	header: {
		display: 'flex',
		flexDirection: 'row',
		gap: '10px',
	},
});

export default Index;
